<template>
  <div class="main-container bg-grey-lightest" v-if="consultant">
    <div class="main-content-wrap">
      <div class="max-center">
        <div class="main-content-pannel">
          <div
            class="option-wrap bg-grey-lightest grey-bg-option no-border"
            style="height: 80px"
          >
            <div class="options">
              <div class="content-title-wrap p-t-0">
                <div class="main-content-title">
                  <div class="main-content-title-person">
                    <div class="avatar-container">
                      <div
                        class="avatar c-p"
                        @click="openAvatarCrop(consultant.email)"
                      >
                        <span v-if="!consultant.photo_url">{{
                          (consultant.name ? consultant.name : consultant.email)
                            | getFirstLetter
                        }}</span>
                        <img v-else :src="consultant.photo_url" alt />
                      </div>
                      <span
                        class="status-pill avatar-ative"
                        :class="{
                          red: !consultant.is_active,
                          green: consultant.is_active,
                        }"
                        :title="consultant.is_active ? 'Active' : 'Inactive'"
                      ></span>
                    </div>
                    <div class="connsultant-resume-info">
                      <div class="connsultant-resume-name">
                        <div>{{ consultant.name }}</div>
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            (consultant.client_confirm ||
                              consultant.reply === 'yes') &&
                            !(
                              consultant.client_confirm &&
                              consultant.reply === 'yes'
                            )
                          "
                          >check</i
                        >
                        <i
                          class="material-icons align-middle font-color-lighter"
                          v-if="
                            consultant.client_confirm &&
                            consultant.reply === 'yes'
                          "
                          >done_all</i
                        >
                        <i
                          class="material-icons align-middle font-color-green"
                          v-if="consultant.verified"
                          >verified</i
                        >
                      </div>
                      <div class="connsultant-resume-location flex">
                        <span class="tech_lvl_tag"
                          ><i class="material-icons align-middle">stream</i
                          >{{ consultant.tech_level }}</span
                        >
                        <i class="material-icons align-middle">location_on</i>
                        {{ consultant.metro }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main-content-menu">
                  <div
                    tag="button"
                    class="btn primary cursor-pointer"
                    @click="toAIReview"
                  >
                    <i class="material-icons-outlined align-middle">laptop</i>
                    AI Review
                  </div>
                  <div
                    tag="button"
                    class="btn primary cursor-pointer"
                    @click="toResumeAnon"
                  >
                    <i class="material-icons-outlined align-middle"
                      >public_off</i
                    >
                    Anonymized
                  </div>
                  <div
                    tag="button"
                    class="btn primary cursor-pointer"
                    @click="toResume"
                  >
                    <i class="material-icons-outlined align-middle">public</i>
                    Pubic View
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-flex m-t-4l">
            <div class="main-flex-1 flex-left">
              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Bio</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn"
                      href="javascript:void(0);"
                      @click="openEditPannel(10, 'Edit Bio', true)"
                      :class="{ active: editOpen == 10 }"
                      title="Edit Bio"
                      >Edit</a
                    >
                  </div>
                </div>
                <div class="pannel-1-body">
                  <p class="preline">{{ consultant.bio }}</p>
                </div>
              </div>
              <div
                class="pannel-1 border-radius-none relative"
                style="min-height: 180px"
                v-if="
                  consultant.interview_url ||
                  (user && user.roles && user.roles.admin)
                "
              >
                <div v-if="consultant.interview_url">
                  <iframe
                    class="video-wrapper iframe-wrapper"
                    :src="consultant.interview_url"
                  />
                </div>
                <div class="pannel-1-title pannel-1-title-float">
                  <h3 v-if="!consultant.interview_url">Video</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn"
                      href="javascript:void(0);"
                      @click="openEditPannel(9, 'Edit Video', true)"
                      :class="{ active: editOpen == 9 }"
                      title="Edit Video"
                      >Edit</a
                    >
                  </div>
                </div>
              </div>

              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Certifications</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn"
                      href="javascript:void(0);"
                      @click="openEditPannel(1, 'Edit Certification', true)"
                      :class="{ active: editOpen == 1 }"
                      >Edit</a
                    >
                  </div>
                </div>
                <div class="pannel-1-body tech-cert-content">
                  <ul
                    v-if="consultant.resume && consultant.resume.certifications"
                  >
                    <li
                      v-for="(certification, index) in consultant.resume
                        .certifications"
                      :key="index"
                    >
                      <a
                        href="javascript:void(0)"
                        class="flex items-center"
                        @click="onClickCertification(index)"
                      >
                        <div
                          class="image"
                          :style="{
                            backgroundImage: `url(${certification.image_url}`,
                          }"
                        ></div>
                        <div
                          class="flex-1"
                          style="color: var(--font-color-lighter; font-weight: 800"
                        >
                          {{ certification.description }}
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Skills</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn"
                      href="javascript:void(0);"
                      @click="openEditPannel(2, 'Edit Skills', true)"
                      :class="{ active: editOpen == 2 }"
                      >Edit</a
                    >
                  </div>
                </div>
                <div class="pannel-1-body tech-cert-content">
                  <ul
                    class="tech-skill-content"
                    v-if="consultant.resume && consultant.resume.skills"
                  >
                    <li
                      v-for="(skill, index) in consultant.resume.skills"
                      :key="index"
                    >
                      <a href="javascript:void(0)">
                        {{ skill }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Tools</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn"
                      href="javascript:void(0);"
                      @click="openEditPannel(3, 'Edit Tools', true)"
                      :class="{ active: editOpen == 3 }"
                      >Edit</a
                    >
                  </div>
                </div>
                <div class="pannel-1-body tech-cert-content">
                  <ul
                    class="tech-skill-content"
                    v-if="consultant.resume && consultant.resume.tools"
                  >
                    <li
                      v-for="(tool, index) in consultant.resume.tools"
                      :key="index"
                    >
                      <a
                        href="javascript:void(0)"
                        @click="onClickTool(index)"
                        >{{ typeof tool === "string" ? tool : tool.name }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="main-flex-2">
              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Work History</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn w-s-n"
                      href="javascript:void(0);"
                      @click="openEditPannel(4, 'Add Work History', true)"
                      :class="{ active: editOpen == 4 }"
                      >Add Work Experience</a
                    >
                  </div>
                </div>
                <div class="hr m-t"></div>
                <div class="pannel-1-body">
                  <section
                    v-if="consultant.resume && consultant.resume.work_histories"
                  >
                    <div
                      v-for="(workHistory, index) in consultant.resume
                        .work_histories"
                      :key="index"
                      class="work-history-experience"
                    >
                      <div class="flex justify-content-between">
                        <div class="work-history-info">
                          <h6>{{ workHistory.company_name }}</h6>
                          <h5>{{ workHistory.job }}</h5>
                          <div>
                            <span
                              >{{
                                workHistory.start_time
                                  | dateformatFilter("MMM YYYY")
                              }}
                              -
                              {{
                                workHistory.end_time
                                  | dateformatFilter("MMM YYYY", true)
                              }}</span
                            >
                            <i class="material-icons align-middle">place</i>
                            {{ workHistory.location }}
                          </div>
                        </div>
                        <div
                          class="work-history-image"
                          :style="{
                            backgroundImage: `url(${workHistory.image_url}`,
                          }"
                          v-if="workHistory.image_url"
                        ></div>
                      </div>

                      <div class="flex-1">
                        <p
                          v-for="(experience, idx) in workHistory.experiences"
                          :key="idx"
                          class="preline"
                        >
                          {{ experience }}
                        </p>
                        <div class="tech-resume-timeline-action">
                          <a
                            href="javascript:void(0)"
                            @click="editWorkHistory(index)"
                          >
                            <i class="material-icons-outlined align-middle"
                              >edit</i
                            >
                          </a>
                          <a
                            href="javascript:void(0)"
                            @click="deleteWorkHistory(index)"
                          >
                            <i class="material-icons-outlined align-middle"
                              >delete</i
                            >
                          </a>
                        </div>
                      </div>

                      <div
                        class="hr m-t-2l"
                        style="margin-left: -20px; margin-right: -20px"
                      ></div>
                    </div>
                  </section>
                </div>
              </div>

              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>Educations</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn w-s-n"
                      href="javascript:void(0);"
                      @click="openEditPannel(6, 'Add Education', true)"
                      :class="{ active: editOpen == 6 }"
                      >Add Education</a
                    >
                  </div>
                </div>
                <div class="hr m-t"></div>
                <div class="pannel-1-body">
                  <section
                    v-if="consultant.resume && consultant.resume.educations"
                  >
                    <div
                      v-for="(education, index) in consultant.resume.educations"
                      :key="index"
                      class="work-history-experience"
                    >
                      <div class="flex justify-content-between">
                        <div class="work-history-info">
                          <h6>{{ education.school_name }}</h6>
                          <h5>{{ education.major }}</h5>
                          <div>
                            <span
                              >{{
                                education.start_time
                                  | dateformatFilter("MMM YYYY")
                              }}
                              -
                              {{
                                education.end_time
                                  | dateformatFilter("MMM YYYY", true)
                              }}</span
                            >
                            <i class="material-icons align-middle">place</i>
                            {{ education.location }}
                          </div>
                        </div>
                        <div
                          class="work-history-image"
                          :style="{
                            backgroundImage: `url(${education.image_url}`,
                          }"
                          v-if="education.image_url"
                        ></div>
                      </div>

                      <div class="flex-1">
                        <p
                          v-for="(experience, idx) in education.experiences"
                          :key="idx"
                          class="preline"
                        >
                          {{ experience }}
                        </p>
                        <div class="tech-resume-timeline-action">
                          <a
                            href="javascript:void(0)"
                            @click="editEducation(index)"
                          >
                            <i class="material-icons-outlined align-middle"
                              >edit</i
                            >
                          </a>
                          <a
                            href="javascript:void(0)"
                            @click="deleteEducation(index)"
                          >
                            <i class="material-icons-outlined align-middle"
                              >delete</i
                            >
                          </a>
                        </div>
                      </div>

                      <div
                        class="hr m-t-2l"
                        style="margin-left: -20px; margin-right: -20px"
                      ></div>
                    </div>
                  </section>
                </div>
              </div>

              <div class="pannel-1 border-radius-none">
                <div class="pannel-1-title">
                  <h3>References</h3>
                  <div class="pannel-1-title-option">
                    <a
                      class="btn w-s-n"
                      href="javascript:void(0);"
                      @click="openEditPannel(8, 'Add References', true)"
                      :class="{ active: editOpen == 8 }"
                      >Add References</a
                    >
                  </div>
                </div>
                <div class="hr m-t"></div>
                <div class="pannel-1-body">
                  <ul
                    class="blockquote"
                    v-if="consultant.resume && consultant.resume.references"
                  >
                    <li
                      v-for="(reference, index) in consultant.resume.references"
                      :key="index"
                    >
                      <p>
                        {{ reference.content }}
                        <span>{{ reference.signature }}</span>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" v-if="consultant.resume" title>
          <PanelResumeCertifications
            v-if="editOpen == 1"
            :propsData="consultant.resume.certifications"
            :certificationSuggestions="certificationSuggestions"
            @onButtonClick="onCertificationsButtonClick"
          ></PanelResumeCertifications>
          <PanelResumeSkills
            v-if="editOpen == 2"
            :propsData="consultant.resume.skills"
            :suggestions="skillSuggestions"
            @onButtonClick="onSkillsButtonClick"
          ></PanelResumeSkills>
          <PanelResumeTools
            v-if="editOpen == 3"
            :propsData="consultant.resume.tools"
            :toolSuggestions="toolSuggestions"
            @onButtonClick="onToolsButtonClick"
          ></PanelResumeTools>
          <PanelResumeWorkHistories
            v-if="editOpen == 4 || editOpen == 5"
            :workHistory="currentWorkHistory"
            :index="workHistoryIndex"
            :type="editOpen == 4 ? 'add' : 'edit'"
            @onButtonClick="onWorkHistoryButtonClick"
          ></PanelResumeWorkHistories>
          <PanelResumeEducations
            v-if="editOpen == 6 || editOpen == 7"
            :education="currentEducation"
            :index="educationIndex"
            :type="editOpen == 6 ? 'add' : 'edit'"
            @onButtonClick="onEducationButtonClick"
          ></PanelResumeEducations>
          <PanelResumeReferences
            v-if="editOpen == 8"
            :propsData="consultant.resume.references"
            @onButtonClick="onReferencesButtonClick"
          ></PanelResumeReferences>
          <PanelResumeVideo
            v-if="editOpen == 9"
            :propsData="consultant.interview_url"
            @onButtonClick="onVideoButtonClick"
          ></PanelResumeVideo>
          <PanelResumeBio
            v-if="editOpen == 10"
            :propsData="consultant.bio"
            @onButtonClick="onBioButtonClick"
          ></PanelResumeBio>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {
  db,
  storage,
  storagePut,
  storageGetDownloadUrl,
} from "@/vendor/firebase";
import { updateDocById } from "@/vendor/database";
import * as utils from "@/utils/utils";
import EditPannel from "@/components/EditPannel.vue";
import PanelResumeCertifications from "@/components/consultant/consultantResume/PanelResumeCertifications.vue";
import PanelResumeSkills from "@/components/consultant/consultantResume/PanelResumeSkills.vue";
import PanelResumeTools from "@/components/consultant/consultantResume/PanelResumeTools.vue";
import PanelResumeReferences from "@/components/consultant/consultantResume/PanelResumeReferences.vue";
import PanelResumeWorkHistories from "@/components/consultant/consultantResume/PanelResumeWorkHistories.vue";
import PanelResumeEducations from "@/components/consultant/consultantResume/PanelResumeEducations.vue";
import PanelResumeVideo from "@/components/consultant/consultantResume/PanelResumeVideo.vue";
import PanelResumeBio from "@/components/consultant/consultantResume/PanelResumeBio.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      queryId: null,

      editOpen: false,
      consultant: null,

      workHistoryIndex: null,
      currentWorkHistory: null,
      educationIndex: null,
      currentEducation: null,
      skills: null,
      skillSuggestions: [],
      tools: null,
      toolSuggestions: [],
      certifications: null,
      certificationSuggestions: [],
    };
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.bindData();
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    EditPannel,
    PanelResumeSkills,
    PanelResumeTools,
    PanelResumeCertifications,
    PanelResumeWorkHistories,
    PanelResumeReferences,
    PanelResumeEducations,
    PanelResumeVideo,
    PanelResumeBio,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    consultant: function () {
      if (!this.consultant) return;
      if (!this.consultant.resume) {
        this.consultant.resume = {};
      }
      if (this.consultant.resume.work_histories)
        this.consultant.resume.work_histories = utils.sortArray(
          this.consultant.resume.work_histories,
          "start_time"
        );
      if (this.consultant.resume.educations)
        this.consultant.resume.educations = utils.sortArray(
          this.consultant.resume.educations,
          "start_time"
        );
      this.updateCertifications();
    },
    skills: function () {
      this.skillSuggestions = this.skills.map((item) => item.name);
    },
    tools: function () {
      this.toolSuggestions = this.tools;
    },
    certifications: function () {
      this.certificationSuggestions = this.certifications;
    },
  },
  methods: {
    openAvatarCrop(email) {
      this.$store.commit("setImagecropperEmail", email);
      this.$store.commit("setImagecropperShow", true);
    },
    bindData: function () {
      if (this.queryId) {
        this.$bind(
          "consultant",
          db.collection("consultants").doc(this.queryId)
        );
      }
      this.$bind("skills", db.collection("skills"));
      this.$bind("tools", db.collection("tools"));
      this.$bind("certifications", db.collection("certifications"));
    },
    deleteEducation: function (index) {
      utils.deleteConfirm(() => {
        this.consultant.resume.educations.splice(index, 1);
        this.saveResume("education delete success");
      });
    },
    editEducation: function (index) {
      this.educationIndex = index;
      this.currentEducation = this.consultant.resume.educations[index];
      this.openEditPannel(7, "Edit Education", true);
    },
    onEducationButtonClick: function (item, type, index) {
      if (type == "add") {
        if (!this.consultant.resume.educations) {
          this.consultant.resume.educations = [];
        }
        this.consultant.resume.educations.push(item);
        this.saveResume("education save success");
      } else if (type == "edit") {
        this.consultant.resume.educations[index] = item;
        this.saveResume("education edit success");
      }
    },
    deleteWorkHistory: function (index) {
      utils.deleteConfirm(() => {
        this.consultant.resume.work_histories.splice(index, 1);
        this.saveResume("work history delete success");
      });
    },
    editWorkHistory: function (index) {
      this.workHistoryIndex = index;
      this.currentWorkHistory = this.consultant.resume.work_histories[index];
      this.openEditPannel(5, "Edit Work History", true);
    },
    onWorkHistoryButtonClick: function (item, type, index) {
      if (type == "add") {
        if (!this.consultant.resume.work_histories) {
          this.consultant.resume.work_histories = [];
        }
        this.consultant.resume.work_histories.push(item);
        this.saveResume("work history save success");
      } else if (type == "edit") {
        this.consultant.resume.work_histories[index] = item;
        this.saveResume("work history save success");
      }
    },
    updateCertifications: async function () {
      if (this.consultant.resume.certifications) {
        for (const i in this.consultant.resume.certifications) {
          const item = this.consultant.resume.certifications[i];
          if (item.image && !item.image_url) {
            const result = await storageGetDownloadUrl("images/" + item.image);
            if (result.ok)
              this.$set(
                this.consultant.resume.certifications[i],
                "image_url",
                result.data
              );
          }
        }
      }
    },
    onCertificationsButtonClick: async function (item) {
      const certifications = [];
      for (const i in item) {
        if (item[i].file) {
          let fileType = item[i].file.type.split("/")[1];
          fileType = fileType == "jpeg" ? "jpg" : fileType;
          const fileName = utils.randomString(10) + "." + fileType;
          const putResult = await storagePut("images/", fileName, item[i].file);
          if (putResult.ok) {
            const getResult = await storageGetDownloadUrl("images/" + fileName);
            certifications.push({
              image: fileName,
              image_url: getResult.ok ? getResult.data : null,
              description: item[i].description ? item[i].description : "",
              link: item[i].link ? item[i].link : null,
            });
          }
        } else {
          certifications.push({
            image: item[i].image ? item[i].image : null,
            image_url: item[i].image_url ? item[i].image_url : null,
            description: item[i].description ? item[i].description : null,
            link: item[i].link ? item[i].link : null,
          });
        }
      }
      this.$set(this.consultant.resume, "certifications", certifications);
      this.saveResume("certifications save success");
    },
    onToolsButtonClick: function (item) {
      this.$set(this.consultant.resume, "tools", item);
      this.saveResume("tools save success");
    },
    onSkillsButtonClick: function (item) {
      this.$set(this.consultant.resume, "skills", item);
      this.saveResume("skills save success");
    },
    onReferencesButtonClick: function (item) {
      this.$set(this.consultant.resume, "references", item);
      this.saveResume("references save success");
    },
    saveResume: function (msg) {
      db.collection("consultants")
        .doc(this.queryId)
        .update({ resume: this.consultant.resume })
        .then((docRef) => {
          this.closeEditPannel();
          this.$toasted.global.toast_success({ message: msg });
        })
        .catch((error) => {
          this.$toasted.global.toast_error({ message: error });
        });
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    onClickCertification: function (index) {
      const link = this.consultant.resume.certifications[index].link;
      if (link) window.open(link, "_blank");
    },
    onClickTool: function (index) {
      if (typeof this.consultant.resume.tools[index] == "object") {
        const link = this.consultant.resume.tools[index].link;
        if (link) window.open(link, "_blank");
      }
    },
    onVideoButtonClick: async function (data) {
      const res = await updateDocById("consultants", this.queryId, {
        interview_url: data ? data : null,
      });
      if (res.ok) {
        this.$toasted.global.toast_success({ message: "success" });
        this.closeEditPannel();
      } else {
        this.$toasted.global.toast_error({ message: "error" });
      }
    },
    onBioButtonClick: async function (data) {
      const res = await updateDocById("consultants", this.queryId, {
        bio: data ? data : null,
      });
      if (res.ok) {
        this.$toasted.global.toast_success({ message: "success" });
        this.closeEditPannel();
      } else {
        this.$toasted.global.toast_error({ message: "error" });
      }
    },
    toAIReview: function () {
      let routeUrl = this.$router.resolve({
        path: "/resume_ai_review/" + this.queryId + "/allinfo",
      });
      window.open(routeUrl.href, "_blank");
    },
    toResumeAnon: function () {
      let routeUrl = this.$router.resolve({
        path: "/resume/" + this.queryId + "/anon",
      });
      window.open(routeUrl.href, "_blank");
    },
    toResume: function () {
      let routeUrl = this.$router.resolve({
        path: "/resume/" + this.queryId + "/allinfo",
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped>
.flex-left {
  flex: 0 0 360px;
}
.iframe-wrapper {
  height: 180px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
